export const cleanHtmlTags = (text) => {
  if (!text) return '';

  return `${text}`
    .replace(/<(?:.|\n)*?>/gm, ' ')
    .replace(/\s+/g, ' ')        
    .trim();                     
};

export const parseDate = (value) => {
  if (!value) return null;
  try {
    const dateObj = new Date(value);
    return isNaN(dateObj.getTime()) ? null : dateObj;
  } catch {
    return null;
  }
};

export const parseNumber = (value) => {
  const floatNumber = parseFloat(value);
  return !isNaN(floatNumber) ? floatNumber : null;
};